import { Card, CardBody, Col } from 'reactstrap';
 import ReactApexChart from 'react-apexcharts';
 import { circleChartData } from '../../../data/dashboard/ChartData';
import CardHeaderCommon from '../../../common-elements/card-header-common/CardHeaderCommon';
 
const RadialBarChart = () => {
  return (
    <Col className='m-0' xl="4"  >
      <Card >
        <CardHeaderCommon title="Plan Performance Breakdown" />
        <CardBody style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 348 }}>
          <ReactApexChart options={circleChartData} series={circleChartData.series} type="radialBar" height={350} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default RadialBarChart;